// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"64e532abe18fc5b4","6831":"936b465510f81dfe","8503":"ad68493328281685","9683":"41e72399bf785bf5"}[chunkId] + ".js";
};